//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import {
  CustomerInfo,
  Directory360, DirectoryDto,
  EmailPreferences,
  File360,
  FileDestinationNamingType,
  FileDto,
  IPaginatedCount,
  Job,
  JobDirectory,
  JobFile,
  JobRunItem,
  JobRunItemStatusType,
  JobRunStatusType, PaginatedCount,
  PaginationData,
  Project,
  ProjectWiseDirectory,
  ProjectWiseFile,
  StorageType, UsageExportFormat, UsageExportType, UsageSortType
} from "./Classes";

/* tslint:disable */
/* eslint-disable */

// ReSharper disable InconsistentNaming


export class BulkJobBase implements IBulkJobBase {
  id?: string;
  userId?: string;
  customerId?: string;
  name?: string;
  startTime?: Date;
  items?: BulkJobItemBase[];
  isCreating?: boolean;
  isCreated?: boolean;

  constructor(data?: IBulkJobBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.userId = _data["userId"];
      this.customerId = _data["customerId"];
      this.name = _data["name"];
      this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(BulkJobItemBase.fromJS(item));
      }
      this.isCreating = _data["isCreating"];
      this.isCreated = _data["isCreated"];
    }
  }

  static fromJS(data: any): BulkJobBase {
    data = typeof data === 'object' ? data : {};
    let result = new BulkJobBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["userId"] = this.userId;
    data["customerId"] = this.customerId;
    data["name"] = this.name;
    data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : <any>undefined);
    }
    data["isCreating"] = this.isCreating;
    data["isCreated"] = this.isCreated;
    return data;
  }
}

export interface IBulkJobBase {
  id?: string;
  userId?: string;
  customerId?: string;
  name?: string;
  startTime?: Date;
  items?: BulkJobItemBase[];
  isCreating?: boolean;
  isCreated?: boolean;
}

export class BulkJob extends BulkJobBase implements IBulkJob {
  items?: BulkJobItem[];
  destinationDirectory?: DirectoryDto;

  constructor(data?: IBulkJob) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(BulkJobItem.fromJS(item));
      }
      this.destinationDirectory = _data["destinationDirectory"] ? DirectoryDto.fromJS(_data["destinationDirectory"]) : <any>undefined;
    }
  }

  static override fromJS(data: any): BulkJob {
    data = typeof data === 'object' ? data : {};
    let result = new BulkJob();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : <any>undefined);
    }
    data["destinationDirectory"] = this.destinationDirectory ? this.destinationDirectory.toJSON() : <any>undefined;
    super.toJSON(data);
    return data;
  }
}

export interface IBulkJob extends IBulkJobBase {
  items?: BulkJobItem[];
  destinationDirectory?: DirectoryDto;
}

export class BulkJobItemBase implements IBulkJobItemBase {
  jobId?: string;

  constructor(data?: IBulkJobItemBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobId = _data["jobId"];
    }
  }

  static fromJS(data: any): BulkJobItemBase {
    data = typeof data === 'object' ? data : {};
    let result = new BulkJobItemBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobId"] = this.jobId;
    return data;
  }
}

export interface IBulkJobItemBase {
  jobId?: string;
}

export class BulkJobItem extends BulkJobItemBase implements IBulkJobItem {
  hubId?: string;
  projectId?: string;

  constructor(data?: IBulkJobItem) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.hubId = _data["hubId"];
      this.projectId = _data["projectId"];
    }
  }

  static override fromJS(data: any): BulkJobItem {
    data = typeof data === 'object' ? data : {};
    let result = new BulkJobItem();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hubId"] = this.hubId;
    data["projectId"] = this.projectId;
    super.toJSON(data);
    return data;
  }
}

export interface IBulkJobItem extends IBulkJobItemBase {
  hubId?: string;
  projectId?: string;
}

export class CreateBulkJobRequestBase implements ICreateBulkJobRequestBase {
  name?: string | undefined;
  startTime?: Date | undefined;
  paused?: boolean;

  constructor(data?: ICreateBulkJobRequestBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
      this.paused = _data["paused"];
    }
  }

  static fromJS(data: any): CreateBulkJobRequestBase {
    data = typeof data === 'object' ? data : {};
    let result = new CreateBulkJobRequestBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
    data["paused"] = this.paused;
    return data;
  }
}

export interface ICreateBulkJobRequestBase {
  name?: string | undefined;
  startTime?: Date | undefined;
  paused?: boolean;
}

export class CreateBulkJobRequest extends CreateBulkJobRequestBase implements ICreateBulkJobRequest {
  destinationDirectory?: DirectoryDto | undefined;
  items?: CreateBulkJobRequestItem[];
  compositeExtractType?: CompositeExtractType;
  jobInterval?: string | undefined;

  constructor(data?: ICreateBulkJobRequest) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.destinationDirectory = _data["destinationDirectory"] ? DirectoryDto.fromJS(_data["destinationDirectory"]) : <any>undefined;
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(CreateBulkJobRequestItem.fromJS(item));
      }
      this.compositeExtractType = _data["compositeExtractType"];
      this.jobInterval = _data["jobInterval"];
    }
  }

  static override fromJS(data: any): CreateBulkJobRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateBulkJobRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["destinationDirectory"] = this.destinationDirectory ? this.destinationDirectory.toJSON() : <any>undefined;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : <any>undefined);
    }
    data["compositeExtractType"] = this.compositeExtractType;
    data["jobInterval"] = this.jobInterval;
    super.toJSON(data);
    return data;
  }
}

export interface ICreateBulkJobRequest extends ICreateBulkJobRequestBase {
  destinationDirectory?: DirectoryDto | undefined;
  items?: CreateBulkJobRequestItem[];
  compositeExtractType?: CompositeExtractType;
  jobInterval?: string | undefined;
}

export class CreateBulkJobRequestItem implements ICreateBulkJobRequestItem {
  hubId?: string | undefined;
  projectId?: string | undefined;
  storageType?: StorageType;

  constructor(data?: ICreateBulkJobRequestItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hubId = _data["hubId"];
      this.projectId = _data["projectId"];
      this.storageType = _data["storageType"];
    }
  }

  static fromJS(data: any): CreateBulkJobRequestItem {
    data = typeof data === 'object' ? data : {};
    let result = new CreateBulkJobRequestItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hubId"] = this.hubId;
    data["projectId"] = this.projectId;
    data["storageType"] = this.storageType;
    return data;
  }
}

export interface ICreateBulkJobRequestItem {
  hubId?: string | undefined;
  projectId?: string | undefined;
  storageType?: StorageType;
}

export enum CompositeExtractType {
  ExtractAll = "ExtractAll",
  CopyComposite = "CopyComposite",
}

export class EditBulkJobRequestBase implements IEditBulkJobRequestBase {
  name?: string | undefined;
  startTime?: Date | undefined;
  pauseJob?: boolean | undefined;

  constructor(data?: IEditBulkJobRequestBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
      this.pauseJob = _data["pauseJob"];
    }
  }

  static fromJS(data: any): EditBulkJobRequestBase {
    data = typeof data === 'object' ? data : {};
    let result = new EditBulkJobRequestBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
    data["pauseJob"] = this.pauseJob;
    return data;
  }
}

export interface IEditBulkJobRequestBase {
  name?: string | undefined;
  startTime?: Date | undefined;
  pauseJob?: boolean | undefined;
}

export class EditBulkJobRequest extends EditBulkJobRequestBase implements IEditBulkJobRequest {
  destinationDirectory?: DirectoryDto | undefined;
  addItems?: CreateBulkJobRequestItem[];
  removeItems?: CreateBulkJobRequestItem[];

  constructor(data?: IEditBulkJobRequest) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.destinationDirectory = _data["destinationDirectory"] ? DirectoryDto.fromJS(_data["destinationDirectory"]) : <any>undefined;
      if (Array.isArray(_data["addItems"])) {
        this.addItems = [] as any;
        for (let item of _data["addItems"])
          this.addItems!.push(CreateBulkJobRequestItem.fromJS(item));
      }
      if (Array.isArray(_data["removeItems"])) {
        this.removeItems = [] as any;
        for (let item of _data["removeItems"])
          this.removeItems!.push(CreateBulkJobRequestItem.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): EditBulkJobRequest {
    data = typeof data === 'object' ? data : {};
    let result = new EditBulkJobRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["destinationDirectory"] = this.destinationDirectory ? this.destinationDirectory.toJSON() : <any>undefined;
    if (Array.isArray(this.addItems)) {
      data["addItems"] = [];
      for (let item of this.addItems)
        data["addItems"].push(item ? item.toJSON() : <any>undefined);
    }
    if (Array.isArray(this.removeItems)) {
      data["removeItems"] = [];
      for (let item of this.removeItems)
        data["removeItems"].push(item ? item.toJSON() : <any>undefined);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IEditBulkJobRequest extends IEditBulkJobRequestBase {
  destinationDirectory?: DirectoryDto | undefined;
  addItems?: CreateBulkJobRequestItem[];
  removeItems?: CreateBulkJobRequestItem[];
}

export class PaginatedResultOfBulkJob extends PaginatedCount implements IPaginatedResultOfBulkJob {
  items?: BulkJob[];

  constructor(data?: IPaginatedResultOfBulkJob) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(BulkJob.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfBulkJob {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfBulkJob();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : <any>undefined);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfBulkJob extends IPaginatedCount {
  items?: BulkJob[];
}

export class BulkJobPaginatedResult extends PaginatedResultOfBulkJob implements IBulkJobPaginatedResult {

  constructor(data?: IBulkJobPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): BulkJobPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new BulkJobPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IBulkJobPaginatedResult extends IPaginatedResultOfBulkJob {
}

export class ExportStatusDto implements IExportStatusDto {
  reportId?: string;
  statusId?: string | undefined;
  isReady?: boolean;

  constructor(data?: IExportStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reportId = _data["reportId"];
      this.statusId = _data["statusId"];
      this.isReady = _data["isReady"];
    }
  }

  static fromJS(data: any): ExportStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExportStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportId"] = this.reportId;
    data["statusId"] = this.statusId;
    data["isReady"] = this.isReady;
    return data;
  }
}

export interface IExportStatusDto {
  reportId?: string;
  statusId?: string | undefined;
  isReady?: boolean;
}

export class ExportResultDto extends ExportStatusDto implements IExportResultDto {
  exports?: { [key: string]: ExportResultFormatDto; };

  constructor(data?: IExportResultDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (_data["exports"]) {
        this.exports = {} as any;
        for (let key in _data["exports"]) {
          if (_data["exports"].hasOwnProperty(key))
            (<any>this.exports)![key] = _data["exports"][key] ? ExportResultFormatDto.fromJS(_data["exports"][key]) : new ExportResultFormatDto();
        }
      }
    }
  }

  static override fromJS(data: any): ExportResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExportResultDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.exports) {
      data["exports"] = {};
      for (let key in this.exports) {
        if (this.exports.hasOwnProperty(key))
          (<any>data["exports"])[key] = this.exports[key] ? this.exports[key].toJSON() : <any>undefined;
      }
    }
    super.toJSON(data);
    return data;
  }
}

export interface IExportResultDto extends IExportStatusDto {
  exports?: { [key: string]: ExportResultFormatDto; };
}

export class ExportResultFormatDto implements IExportResultFormatDto {
  format?: string;
  failureMessage?: string | undefined;
  fileName?: string | undefined;
  exportUri?: string | undefined;
  bim360ProjectId?: string | undefined;
  bim360ItemId?: string | undefined;
  exportS3Key?: string | undefined;

  constructor(data?: IExportResultFormatDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.format = _data["format"];
      this.failureMessage = _data["failureMessage"];
      this.fileName = _data["fileName"];
      this.exportUri = _data["exportUri"];
      this.bim360ProjectId = _data["bim360ProjectId"];
      this.bim360ItemId = _data["bim360ItemId"];
      this.exportS3Key = _data["exportS3Key"];
    }
  }

  static fromJS(data: any): ExportResultFormatDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExportResultFormatDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["format"] = this.format;
    data["failureMessage"] = this.failureMessage;
    data["fileName"] = this.fileName;
    data["exportUri"] = this.exportUri;
    data["bim360ProjectId"] = this.bim360ProjectId;
    data["bim360ItemId"] = this.bim360ItemId;
    data["exportS3Key"] = this.exportS3Key;
    return data;
  }
}

export interface IExportResultFormatDto {
  format?: string;
  failureMessage?: string | undefined;
  fileName?: string | undefined;
  exportUri?: string | undefined;
  bim360ProjectId?: string | undefined;
  bim360ItemId?: string | undefined;
  exportS3Key?: string | undefined;
}

export class ExportReportRequestOfExportReportOptions implements IExportReportRequestOfExportReportOptions {
  options?: ExportReportOptions | undefined;
  reportId?: string;
  jobRunId?: string | undefined;

  constructor(data?: IExportReportRequestOfExportReportOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.options = _data["options"] ? ExportReportOptions.fromJS(_data["options"]) : <any>undefined;
      this.reportId = _data["reportId"];
      this.jobRunId = _data["jobRunId"];
    }
  }

  static fromJS(data: any): ExportReportRequestOfExportReportOptions {
    data = typeof data === 'object' ? data : {};
    let result = new ExportReportRequestOfExportReportOptions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["options"] = this.options ? this.options.toJSON() : <any>undefined;
    data["reportId"] = this.reportId;
    data["jobRunId"] = this.jobRunId;
    return data;
  }
}

export interface IExportReportRequestOfExportReportOptions {
  options?: ExportReportOptions | undefined;
  reportId?: string;
  jobRunId?: string | undefined;
}

export class ExportReportRequest extends ExportReportRequestOfExportReportOptions implements IExportReportRequest {

  constructor(data?: IExportReportRequest) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ExportReportRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ExportReportRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IExportReportRequest extends IExportReportRequestOfExportReportOptions {
}

export class ExportReportOptions implements IExportReportOptions {
  locationType?: ExportReportLocationType;
  destinationNamingType?: FileDestinationNamingType;
  locationProjectId?: string | undefined;
  locationDirectoryId?: string | undefined;
  emailPreferences?: EmailPreferences | undefined;
  customFileSuffix?: string | undefined;
  hasExportDestination?: boolean;
  exportFormats?: string[];
  force?: boolean;

  constructor(data?: IExportReportOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationType = _data["locationType"];
      this.destinationNamingType = _data["destinationNamingType"];
      this.locationProjectId = _data["locationProjectId"];
      this.locationDirectoryId = _data["locationDirectoryId"];
      this.emailPreferences = _data["emailPreferences"] ? EmailPreferences.fromJS(_data["emailPreferences"]) : <any>undefined;
      this.customFileSuffix = _data["customFileSuffix"];
      this.hasExportDestination = _data["hasExportDestination"];
      if (Array.isArray(_data["exportFormats"])) {
        this.exportFormats = [] as any;
        for (let item of _data["exportFormats"])
          this.exportFormats!.push(item);
      }
      this.force = _data["force"];
    }
  }

  static fromJS(data: any): ExportReportOptions {
    data = typeof data === 'object' ? data : {};
    let result = new ExportReportOptions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["locationType"] = this.locationType;
    data["destinationNamingType"] = this.destinationNamingType;
    data["locationProjectId"] = this.locationProjectId;
    data["locationDirectoryId"] = this.locationDirectoryId;
    data["emailPreferences"] = this.emailPreferences ? this.emailPreferences.toJSON() : <any>undefined;
    data["customFileSuffix"] = this.customFileSuffix;
    data["hasExportDestination"] = this.hasExportDestination;
    if (Array.isArray(this.exportFormats)) {
      data["exportFormats"] = [];
      for (let item of this.exportFormats)
        data["exportFormats"].push(item);
    }
    data["force"] = this.force;
    return data;
  }
}

export interface IExportReportOptions {
  locationType?: ExportReportLocationType;
  destinationNamingType?: FileDestinationNamingType;
  locationProjectId?: string | undefined;
  locationDirectoryId?: string | undefined;
  emailPreferences?: EmailPreferences | undefined;
  customFileSuffix?: string | undefined;
  hasExportDestination?: boolean;
  exportFormats?: string[];
  force?: boolean;
}

export enum ExportReportLocationType {
  None = "None",
  ModelDirectory = "ModelDirectory",
  ModelSubdirectory = "ModelSubdirectory",
  OtherDirectory = "OtherDirectory",
}

export class BatchDeleteResponse implements IBatchDeleteResponse {
  failedIds?: BatchDeleteError[];
  successfulIds?: string[];

  constructor(data?: IBatchDeleteResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["failedIds"])) {
        this.failedIds = [] as any;
        for (let item of _data["failedIds"])
          this.failedIds!.push(BatchDeleteError.fromJS(item));
      }
      if (Array.isArray(_data["successfulIds"])) {
        this.successfulIds = [] as any;
        for (let item of _data["successfulIds"])
          this.successfulIds!.push(item);
      }
    }
  }

  static fromJS(data: any): BatchDeleteResponse {
    data = typeof data === 'object' ? data : {};
    let result = new BatchDeleteResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.failedIds)) {
      data["failedIds"] = [];
      for (let item of this.failedIds)
        data["failedIds"].push(item ? item.toJSON() : <any>undefined);
    }
    if (Array.isArray(this.successfulIds)) {
      data["successfulIds"] = [];
      for (let item of this.successfulIds)
        data["successfulIds"].push(item);
    }
    return data;
  }
}

export interface IBatchDeleteResponse {
  failedIds?: BatchDeleteError[];
  successfulIds?: string[];
}

export class BatchDeleteError implements IBatchDeleteError {
  id?: string;
  error?: string;

  constructor(data?: IBatchDeleteError) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.error = _data["error"];
    }
  }

  static fromJS(data: any): BatchDeleteError {
    data = typeof data === 'object' ? data : {};
    let result = new BatchDeleteError();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["error"] = this.error;
    return data;
  }
}

export interface IBatchDeleteError {
  id?: string;
  error?: string;
}

export class ReportSummaryDto implements IReportSummaryDto {
  reportId?: string;
  reportKey?: string | undefined;
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;
  startTime?: Date;
  endTime?: Date;
  jobName?: string;
  jobId?: string;
  jobRunId?: string;
  status?: JobRunStatusType;
  userId?: string;
  email?: string;
  customerId?: string;
  files?: FileDto[];

  constructor(data?: IReportSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reportId = _data["reportId"];
      this.reportKey = _data["reportKey"];
      this.totalFiles = _data["totalFiles"];
      this.successFiles = _data["successFiles"];
      this.failedFiles = _data["failedFiles"];
      this.pendingFiles = _data["pendingFiles"];
      this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
      this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
      this.jobName = _data["jobName"];
      this.jobId = _data["jobId"];
      this.jobRunId = _data["jobRunId"];
      this.status = _data["status"];
      this.userId = _data["userId"];
      this.email = _data["email"];
      this.customerId = _data["customerId"];
      if (Array.isArray(_data["files"])) {
        this.files = [] as any;
        for (let item of _data["files"])
          this.files!.push(FileDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ReportSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new ReportSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportId"] = this.reportId;
    data["reportKey"] = this.reportKey;
    data["totalFiles"] = this.totalFiles;
    data["successFiles"] = this.successFiles;
    data["failedFiles"] = this.failedFiles;
    data["pendingFiles"] = this.pendingFiles;
    data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
    data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
    data["jobName"] = this.jobName;
    data["jobId"] = this.jobId;
    data["jobRunId"] = this.jobRunId;
    data["status"] = this.status;
    data["userId"] = this.userId;
    data["email"] = this.email;
    data["customerId"] = this.customerId;
    if (Array.isArray(this.files)) {
      data["files"] = [];
      for (let item of this.files)
        data["files"].push(item ? item.toJSON() : <any>undefined);
    }
    return data;
  }
}

export interface IReportSummaryDto {
  reportId?: string;
  reportKey?: string | undefined;
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;
  startTime?: Date;
  endTime?: Date;
  jobName?: string;
  jobId?: string;
  jobRunId?: string;
  status?: JobRunStatusType;
  userId?: string;
  email?: string;
  customerId?: string;
  files?: FileDto[];
}

export class DeckardReportSummaryDto extends ReportSummaryDto implements IDeckardReportSummaryDto {

  constructor(data?: IDeckardReportSummaryDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): DeckardReportSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new DeckardReportSummaryDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IDeckardReportSummaryDto extends IReportSummaryDto {
}

export class DeckardTransferLogDto extends DeckardReportSummaryDto implements IDeckardTransferLogDto {
  items?: JobRunItem[];
  sourceProject?: Project | undefined;
  destinationProject?: Project | undefined;

  constructor(data?: IDeckardTransferLogDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(JobRunItem.fromJS(item));
      }
      this.sourceProject = _data["sourceProject"] ? Project.fromJS(_data["sourceProject"]) : <any>undefined;
      this.destinationProject = _data["destinationProject"] ? Project.fromJS(_data["destinationProject"]) : <any>undefined;
    }
  }

  static override fromJS(data: any): DeckardTransferLogDto {
    data = typeof data === 'object' ? data : {};
    let result = new DeckardTransferLogDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : <any>undefined);
    }
    data["sourceProject"] = this.sourceProject ? this.sourceProject.toJSON() : <any>undefined;
    data["destinationProject"] = this.destinationProject ? this.destinationProject.toJSON() : <any>undefined;
    super.toJSON(data);
    return data;
  }
}

export interface IDeckardTransferLogDto extends IDeckardReportSummaryDto {
  items?: JobRunItem[];
  sourceProject?: Project | undefined;
  destinationProject?: Project | undefined;
}

export enum CloudFileType {
  Standard = "Standard",
  Cloud = "Cloud",
  CloudWorkshared = "CloudWorkshared",
}

export enum ProjectWiseFileClass {
  Document = "Document",
  LogicalSet = "LogicalSet",
  FlatSet = "FlatSet",
}

export class PaginatedResultOfJob extends PaginatedCount implements IPaginatedResultOfJob {
  items?: Job[];

  constructor(data?: IPaginatedResultOfJob) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(Job.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfJob {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfJob();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : <any>undefined);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfJob extends IPaginatedCount {
  items?: Job[];
}

export class JobPaginatedResult extends PaginatedResultOfJob implements IJobPaginatedResult {

  constructor(data?: IJobPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): JobPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new JobPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IJobPaginatedResult extends IPaginatedResultOfJob {
}

export class PaginatedResultOfDeckardItemReportSummaryDto extends PaginatedCount implements IPaginatedResultOfDeckardItemReportSummaryDto {
  items?: DeckardItemReportSummaryDto[];

  constructor(data?: IPaginatedResultOfDeckardItemReportSummaryDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(DeckardItemReportSummaryDto.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfDeckardItemReportSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfDeckardItemReportSummaryDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : <any>undefined);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfDeckardItemReportSummaryDto extends IPaginatedCount {
  items?: DeckardItemReportSummaryDto[];
}

export class ListItemReportHistoryResult extends PaginatedResultOfDeckardItemReportSummaryDto implements IListItemReportHistoryResult {

  constructor(data?: IListItemReportHistoryResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ListItemReportHistoryResult {
    data = typeof data === 'object' ? data : {};
    let result = new ListItemReportHistoryResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IListItemReportHistoryResult extends IPaginatedResultOfDeckardItemReportSummaryDto {
}

export class ItemReportSummaryDto implements IItemReportSummaryDto {
  jobRunItemId?: string;
  status?: JobRunItemStatusType;
  file?: FileDto | undefined;
  summary?: ReportSummaryDto;

  constructor(data?: IItemReportSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobRunItemId = _data["jobRunItemId"];
      this.status = _data["status"];
      this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
      this.summary = _data["summary"] ? ReportSummaryDto.fromJS(_data["summary"]) : <any>undefined;
    }
  }

  static fromJS(data: any): ItemReportSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new ItemReportSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobRunItemId"] = this.jobRunItemId;
    data["status"] = this.status;
    data["file"] = this.file ? this.file.toJSON() : <any>undefined;
    data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
    return data;
  }
}

export interface IItemReportSummaryDto {
  jobRunItemId?: string;
  status?: JobRunItemStatusType;
  file?: FileDto | undefined;
  summary?: ReportSummaryDto;
}

export class DeckardItemReportSummaryDto extends ItemReportSummaryDto implements IDeckardItemReportSummaryDto {
  summary?: DeckardReportSummaryDto;
  destinationFile?: FileDto | undefined;
  sourcePath?: string;
  destinationPath?: string;
  fileSize?: number;

  constructor(data?: IDeckardItemReportSummaryDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.summary = _data["summary"] ? DeckardReportSummaryDto.fromJS(_data["summary"]) : <any>undefined;
      this.destinationFile = _data["destinationFile"] ? FileDto.fromJS(_data["destinationFile"]) : <any>undefined;
      this.sourcePath = _data["sourcePath"];
      this.destinationPath = _data["destinationPath"];
      this.fileSize = _data["fileSize"];
    }
  }

  static override fromJS(data: any): DeckardItemReportSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new DeckardItemReportSummaryDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
    data["destinationFile"] = this.destinationFile ? this.destinationFile.toJSON() : <any>undefined;
    data["sourcePath"] = this.sourcePath;
    data["destinationPath"] = this.destinationPath;
    data["fileSize"] = this.fileSize;
    super.toJSON(data);
    return data;
  }
}

export interface IDeckardItemReportSummaryDto extends IItemReportSummaryDto {
  summary?: DeckardReportSummaryDto;
  destinationFile?: FileDto | undefined;
  sourcePath?: string;
  destinationPath?: string;
  fileSize?: number;
}

export class PaginatedResultOfDeckardReportSummaryDto extends PaginatedCount implements IPaginatedResultOfDeckardReportSummaryDto {
  items?: DeckardReportSummaryDto[];

  constructor(data?: IPaginatedResultOfDeckardReportSummaryDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(DeckardReportSummaryDto.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfDeckardReportSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfDeckardReportSummaryDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : <any>undefined);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfDeckardReportSummaryDto extends IPaginatedCount {
  items?: DeckardReportSummaryDto[];
}

export class ListReportHistoryResult extends PaginatedResultOfDeckardReportSummaryDto implements IListReportHistoryResult {

  constructor(data?: IListReportHistoryResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ListReportHistoryResult {
    data = typeof data === 'object' ? data : {};
    let result = new ListReportHistoryResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IListReportHistoryResult extends IPaginatedResultOfDeckardReportSummaryDto {
}

export class UsageRequestBase implements IUsageRequestBase {
  filter?: UsageFilterDto;
  sort?: UsageSortDto;
  exportType?: UsageExportType;
  exportFormat?: UsageExportFormat;
  writeIfEmpty?: boolean;

  protected _discriminator: string;

  constructor(data?: IUsageRequestBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "UsageRequestBase";
  }

  init(_data?: any) {
    if (_data) {
      this.filter = _data["filter"] ? UsageFilterDto.fromJS(_data["filter"]) : <any>undefined;
      this.sort = _data["sort"] ? UsageSortDto.fromJS(_data["sort"]) : <any>undefined;
      this.exportType = _data["exportType"];
      this.exportFormat = _data["exportFormat"];
      this.writeIfEmpty = _data["writeIfEmpty"];
    }
  }

  static fromJS(data: any): UsageRequestBase {
    data = typeof data === 'object' ? data : {};
    if (data["_discriminator"] === "UsageSummaryRequest") {
      let result = new UsageSummaryRequest();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "UsageRequest") {
      let result = new UsageRequest();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "DetailedUsageRequest") {
      let result = new DetailedUsageRequest();
      result.init(data);
      return result;
    }
    let result = new UsageRequestBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["_discriminator"] = this._discriminator;
    data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
    data["sort"] = this.sort ? this.sort.toJSON() : <any>undefined;
    data["exportType"] = this.exportType;
    data["exportFormat"] = this.exportFormat;
    data["writeIfEmpty"] = this.writeIfEmpty;
    return data;
  }
}

export interface IUsageRequestBase {
  filter?: UsageFilterDto;
  sort?: UsageSortDto;
  exportType?: UsageExportType;
  exportFormat?: UsageExportFormat;
  writeIfEmpty?: boolean;
}

export class UsageRequest extends UsageRequestBase implements IUsageRequest {
  limit?: number | undefined;
  paginationToken?: string | undefined;

  constructor(data?: IUsageRequest) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "UsageRequest";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.limit = _data["limit"];
      this.paginationToken = _data["paginationToken"];
    }
  }

  static override fromJS(data: any): UsageRequest {
    data = typeof data === 'object' ? data : {};
    if (data["_discriminator"] === "UsageSummaryRequest") {
      let result = new UsageSummaryRequest();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "DetailedUsageRequest") {
      let result = new DetailedUsageRequest();
      result.init(data);
      return result;
    }
    let result = new UsageRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["limit"] = this.limit;
    data["paginationToken"] = this.paginationToken;
    super.toJSON(data);
    return data;
  }
}

export interface IUsageRequest extends IUsageRequestBase {
  limit?: number | undefined;
  paginationToken?: string | undefined;
}

export class UsageSummaryRequest extends UsageRequest implements IUsageSummaryRequest {
  statuses?: JobRunStatusType[];
  includeRuns?: boolean;

  constructor(data?: IUsageSummaryRequest) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "UsageSummaryRequest";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["statuses"])) {
        this.statuses = [] as any;
        for (let item of _data["statuses"])
          this.statuses!.push(item);
      }
      this.includeRuns = _data["includeRuns"];
    }
  }

  static override fromJS(data: any): UsageSummaryRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UsageSummaryRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.statuses)) {
      data["statuses"] = [];
      for (let item of this.statuses)
        data["statuses"].push(item);
    }
    data["includeRuns"] = this.includeRuns;
    super.toJSON(data);
    return data;
  }
}

export interface IUsageSummaryRequest extends IUsageRequest {
  statuses?: JobRunStatusType[];
  includeRuns?: boolean;
}

export class UsageFilterDto implements IUsageFilterDto {
  customerIds?: string[];
  userIds?: string[];
  jobIds?: string[];
  startTime?: Date | undefined;
  endTime?: Date | undefined;

  constructor(data?: IUsageFilterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["customerIds"])) {
        this.customerIds = [] as any;
        for (let item of _data["customerIds"])
          this.customerIds!.push(item);
      }
      if (Array.isArray(_data["userIds"])) {
        this.userIds = [] as any;
        for (let item of _data["userIds"])
          this.userIds!.push(item);
      }
      if (Array.isArray(_data["jobIds"])) {
        this.jobIds = [] as any;
        for (let item of _data["jobIds"])
          this.jobIds!.push(item);
      }
      this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
      this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): UsageFilterDto {
    data = typeof data === 'object' ? data : {};
    let result = new UsageFilterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.customerIds)) {
      data["customerIds"] = [];
      for (let item of this.customerIds)
        data["customerIds"].push(item);
    }
    if (Array.isArray(this.userIds)) {
      data["userIds"] = [];
      for (let item of this.userIds)
        data["userIds"].push(item);
    }
    if (Array.isArray(this.jobIds)) {
      data["jobIds"] = [];
      for (let item of this.jobIds)
        data["jobIds"].push(item);
    }
    data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
    data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
    return data;
  }
}

export interface IUsageFilterDto {
  customerIds?: string[];
  userIds?: string[];
  jobIds?: string[];
  startTime?: Date | undefined;
  endTime?: Date | undefined;
}

export class UsageSortDto implements IUsageSortDto {
  sortType?: UsageSortType;
  ascending?: boolean;

  constructor(data?: IUsageSortDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sortType = _data["sortType"];
      this.ascending = _data["ascending"];
    }
  }

  static fromJS(data: any): UsageSortDto {
    data = typeof data === 'object' ? data : {};
    let result = new UsageSortDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["sortType"] = this.sortType;
    data["ascending"] = this.ascending;
    return data;
  }
}

export interface IUsageSortDto {
  sortType?: UsageSortType;
  ascending?: boolean;
}

export class DetailedUsageRequest extends UsageRequest implements IDetailedUsageRequest {
  statuses?: JobRunItemStatusType[];

  constructor(data?: IDetailedUsageRequest) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "DetailedUsageRequest";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["statuses"])) {
        this.statuses = [] as any;
        for (let item of _data["statuses"])
          this.statuses!.push(item);
      }
    }
  }

  static override fromJS(data: any): DetailedUsageRequest {
    data = typeof data === 'object' ? data : {};
    let result = new DetailedUsageRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.statuses)) {
      data["statuses"] = [];
      for (let item of this.statuses)
        data["statuses"].push(item);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IDetailedUsageRequest extends IUsageRequest {
  statuses?: JobRunItemStatusType[];
}

export class PaginatedResultOfCustomerInfo extends PaginatedCount implements IPaginatedResultOfCustomerInfo {
  items?: CustomerInfo[];

  constructor(data?: IPaginatedResultOfCustomerInfo) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(CustomerInfo.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfCustomerInfo {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfCustomerInfo();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : <any>undefined);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfCustomerInfo extends IPaginatedCount {
  items?: CustomerInfo[];
}

export class CustomerInfoPaginatedResult extends PaginatedResultOfCustomerInfo implements ICustomerInfoPaginatedResult {

  constructor(data?: ICustomerInfoPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): CustomerInfoPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerInfoPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface ICustomerInfoPaginatedResult extends IPaginatedResultOfCustomerInfo {
}

export class RecentItemsList implements IRecentItemsList {
  forgeFiles?: JobFile[];
  forgeDirectories?: JobDirectory[];
  projectWiseFiles?: ProjectWiseFile[];
  projectWiseDirectories?: ProjectWiseDirectory[];

  constructor(data?: IRecentItemsList) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["forgeFiles"])) {
        this.forgeFiles = [] as any;
        for (let item of _data["forgeFiles"])
          this.forgeFiles!.push(JobFile.fromJS(item));
      }
      if (Array.isArray(_data["forgeDirectories"])) {
        this.forgeDirectories = [] as any;
        for (let item of _data["forgeDirectories"])
          this.forgeDirectories!.push(JobDirectory.fromJS(item));
      }
      if (Array.isArray(_data["projectWiseFiles"])) {
        this.projectWiseFiles = [] as any;
        for (let item of _data["projectWiseFiles"])
          this.projectWiseFiles!.push(ProjectWiseFile.fromJS(item));
      }
      if (Array.isArray(_data["projectWiseDirectories"])) {
        this.projectWiseDirectories = [] as any;
        for (let item of _data["projectWiseDirectories"])
          this.projectWiseDirectories!.push(ProjectWiseDirectory.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RecentItemsList {
    data = typeof data === 'object' ? data : {};
    let result = new RecentItemsList();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.forgeFiles)) {
      data["forgeFiles"] = [];
      for (let item of this.forgeFiles)
        data["forgeFiles"].push(item ? item.toJSON() : <any>undefined);
    }
    if (Array.isArray(this.forgeDirectories)) {
      data["forgeDirectories"] = [];
      for (let item of this.forgeDirectories)
        data["forgeDirectories"].push(item ? item.toJSON() : <any>undefined);
    }
    if (Array.isArray(this.projectWiseFiles)) {
      data["projectWiseFiles"] = [];
      for (let item of this.projectWiseFiles)
        data["projectWiseFiles"].push(item ? item.toJSON() : <any>undefined);
    }
    if (Array.isArray(this.projectWiseDirectories)) {
      data["projectWiseDirectories"] = [];
      for (let item of this.projectWiseDirectories)
        data["projectWiseDirectories"].push(item ? item.toJSON() : <any>undefined);
    }
    return data;
  }
}

export interface IRecentItemsList {
  forgeFiles?: JobFile[];
  forgeDirectories?: JobDirectory[];
  projectWiseFiles?: ProjectWiseFile[];
  projectWiseDirectories?: ProjectWiseDirectory[];
}

export class ListRecentItemsResult extends RecentItemsList implements IListRecentItemsResult {
  paginationData?: PaginationData | undefined;
  isDone?: boolean;

  constructor(data?: IListRecentItemsResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.paginationData = _data["paginationData"] ? PaginationData.fromJS(_data["paginationData"]) : <any>undefined;
      this.isDone = _data["isDone"];
    }
  }

  static override fromJS(data: any): ListRecentItemsResult {
    data = typeof data === 'object' ? data : {};
    let result = new ListRecentItemsResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["paginationData"] = this.paginationData ? this.paginationData.toJSON() : <any>undefined;
    data["isDone"] = this.isDone;
    super.toJSON(data);
    return data;
  }
}

export interface IListRecentItemsResult extends IRecentItemsList {
  paginationData?: PaginationData | undefined;
  isDone?: boolean;
}

export class PaginatedResultOfJobFile extends PaginatedCount implements IPaginatedResultOfJobFile {
  items?: JobFile[];

  constructor(data?: IPaginatedResultOfJobFile) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(JobFile.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfJobFile {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfJobFile();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : <any>undefined);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfJobFile extends IPaginatedCount {
  items?: JobFile[];
}

export class JobFilePaginatedResult extends PaginatedResultOfJobFile implements IJobFilePaginatedResult {

  constructor(data?: IJobFilePaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): JobFilePaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new JobFilePaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IJobFilePaginatedResult extends IPaginatedResultOfJobFile {
}

export class CreateDirectoryRequest implements ICreateDirectoryRequest {
  name?: string;

  constructor(data?: ICreateDirectoryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): CreateDirectoryRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateDirectoryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    return data;
  }
}

export interface ICreateDirectoryRequest {
  name?: string;
}

export class ListFilesResultBaseOfFile360AndDirectory360AndPaginationData implements IListFilesResultBaseOfFile360AndDirectory360AndPaginationData {
  files?: File360[];
  directories?: Directory360[];
  nextPage?: PaginationData | undefined;
  previousPage?: PaginationData | undefined;
  isDone?: boolean;

  constructor(data?: IListFilesResultBaseOfFile360AndDirectory360AndPaginationData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["files"])) {
        this.files = [] as any;
        for (let item of _data["files"])
          this.files!.push(File360.fromJS(item));
      }
      if (Array.isArray(_data["directories"])) {
        this.directories = [] as any;
        for (let item of _data["directories"])
          this.directories!.push(Directory360.fromJS(item));
      }
      this.nextPage = _data["nextPage"] ? PaginationData.fromJS(_data["nextPage"]) : <any>undefined;
      this.previousPage = _data["previousPage"] ? PaginationData.fromJS(_data["previousPage"]) : <any>undefined;
      this.isDone = _data["isDone"];
    }
  }

  static fromJS(data: any): ListFilesResultBaseOfFile360AndDirectory360AndPaginationData {
    data = typeof data === 'object' ? data : {};
    let result = new ListFilesResultBaseOfFile360AndDirectory360AndPaginationData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.files)) {
      data["files"] = [];
      for (let item of this.files)
        data["files"].push(item ? item.toJSON() : <any>undefined);
    }
    if (Array.isArray(this.directories)) {
      data["directories"] = [];
      for (let item of this.directories)
        data["directories"].push(item ? item.toJSON() : <any>undefined);
    }
    data["nextPage"] = this.nextPage ? this.nextPage.toJSON() : <any>undefined;
    data["previousPage"] = this.previousPage ? this.previousPage.toJSON() : <any>undefined;
    data["isDone"] = this.isDone;
    return data;
  }
}

export interface IListFilesResultBaseOfFile360AndDirectory360AndPaginationData {
  files?: File360[];
  directories?: Directory360[];
  nextPage?: PaginationData | undefined;
  previousPage?: PaginationData | undefined;
  isDone?: boolean;
}

export class ListFilesResultBaseOfFile360AndDirectory360 extends ListFilesResultBaseOfFile360AndDirectory360AndPaginationData implements IListFilesResultBaseOfFile360AndDirectory360 {

  constructor(data?: IListFilesResultBaseOfFile360AndDirectory360) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ListFilesResultBaseOfFile360AndDirectory360 {
    data = typeof data === 'object' ? data : {};
    let result = new ListFilesResultBaseOfFile360AndDirectory360();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IListFilesResultBaseOfFile360AndDirectory360 extends IListFilesResultBaseOfFile360AndDirectory360AndPaginationData {
}

export class ListFilesV2Result extends ListFilesResultBaseOfFile360AndDirectory360 implements IListFilesV2Result {
  specialFilter?: boolean;

  constructor(data?: IListFilesV2Result) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.specialFilter = _data["specialFilter"];
    }
  }

  static override fromJS(data: any): ListFilesV2Result {
    data = typeof data === 'object' ? data : {};
    let result = new ListFilesV2Result();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["specialFilter"] = this.specialFilter;
    super.toJSON(data);
    return data;
  }
}

export interface IListFilesV2Result extends IListFilesResultBaseOfFile360AndDirectory360 {
  specialFilter?: boolean;
}

export class PaginatedResultOfProject extends PaginatedCount implements IPaginatedResultOfProject {
  items?: Project[];

  constructor(data?: IPaginatedResultOfProject) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(Project.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfProject {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfProject();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : <any>undefined);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfProject extends IPaginatedCount {
  items?: Project[];
}

export class ProjectPaginatedResult extends PaginatedResultOfProject implements IProjectPaginatedResult {

  constructor(data?: IProjectPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ProjectPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IProjectPaginatedResult extends IPaginatedResultOfProject {
}

export class PaginatedResultOfProjectWiseRepository extends PaginatedCount implements IPaginatedResultOfProjectWiseRepository {
  items?: ProjectWiseRepository[];

  constructor(data?: IPaginatedResultOfProjectWiseRepository) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(ProjectWiseRepository.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfProjectWiseRepository {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfProjectWiseRepository();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : <any>undefined);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfProjectWiseRepository extends IPaginatedCount {
  items?: ProjectWiseRepository[];
}

export class ProjectWiseRepositoryPaginatedResult extends PaginatedResultOfProjectWiseRepository implements IProjectWiseRepositoryPaginatedResult {

  constructor(data?: IProjectWiseRepositoryPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ProjectWiseRepositoryPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectWiseRepositoryPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IProjectWiseRepositoryPaginatedResult extends IPaginatedResultOfProjectWiseRepository {
}

export class ProjectWiseRepository implements IProjectWiseRepository {
  serverAddress?: string;
  id?: string;
  name?: string;
  credentialId?: string | undefined;

  constructor(data?: IProjectWiseRepository) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serverAddress = _data["serverAddress"];
      this.id = _data["id"];
      this.name = _data["name"];
      this.credentialId = _data["credentialId"];
    }
  }

  static fromJS(data: any): ProjectWiseRepository {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectWiseRepository();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["serverAddress"] = this.serverAddress;
    data["id"] = this.id;
    data["name"] = this.name;
    data["credentialId"] = this.credentialId;
    return data;
  }
}

export interface IProjectWiseRepository {
  serverAddress?: string;
  id?: string;
  name?: string;
  credentialId?: string | undefined;
}

export class ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData implements IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData {
  files?: ProjectWiseFile[];
  directories?: ProjectWiseDirectory[];
  nextPage?: PaginationData | undefined;
  previousPage?: PaginationData | undefined;
  isDone?: boolean;

  constructor(data?: IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["files"])) {
        this.files = [] as any;
        for (let item of _data["files"])
          this.files!.push(ProjectWiseFile.fromJS(item));
      }
      if (Array.isArray(_data["directories"])) {
        this.directories = [] as any;
        for (let item of _data["directories"])
          this.directories!.push(ProjectWiseDirectory.fromJS(item));
      }
      this.nextPage = _data["nextPage"] ? PaginationData.fromJS(_data["nextPage"]) : <any>undefined;
      this.previousPage = _data["previousPage"] ? PaginationData.fromJS(_data["previousPage"]) : <any>undefined;
      this.isDone = _data["isDone"];
    }
  }

  static fromJS(data: any): ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData {
    data = typeof data === 'object' ? data : {};
    let result = new ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.files)) {
      data["files"] = [];
      for (let item of this.files)
        data["files"].push(item ? item.toJSON() : <any>undefined);
    }
    if (Array.isArray(this.directories)) {
      data["directories"] = [];
      for (let item of this.directories)
        data["directories"].push(item ? item.toJSON() : <any>undefined);
    }
    data["nextPage"] = this.nextPage ? this.nextPage.toJSON() : <any>undefined;
    data["previousPage"] = this.previousPage ? this.previousPage.toJSON() : <any>undefined;
    data["isDone"] = this.isDone;
    return data;
  }
}

export interface IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData {
  files?: ProjectWiseFile[];
  directories?: ProjectWiseDirectory[];
  nextPage?: PaginationData | undefined;
  previousPage?: PaginationData | undefined;
  isDone?: boolean;
}

export class ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory extends ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData implements IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory {

  constructor(data?: IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory {
    data = typeof data === 'object' ? data : {};
    let result = new ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory extends IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData {
}

export class ListProjectWiseFilesResult extends ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory implements IListProjectWiseFilesResult {

  constructor(data?: IListProjectWiseFilesResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ListProjectWiseFilesResult {
    data = typeof data === 'object' ? data : {};
    let result = new ListProjectWiseFilesResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IListProjectWiseFilesResult extends IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory {
}